<template>
    <v-container v-resize="onResize">
       
        <v-layout row wrap align-center>
            <v-flex xs12 md6>
                <statistical-header containedInCol="true" ></statistical-header>
                <h1>Parliamentary Parties</h1>
            </v-flex>
            <v-flex xs12 md6>
                <v-layout v-show="!loading" row wrap>
                    <v-flex sm4 offset-sm4>
                        <count-up :endVal="totalParties" text="Total parties in Parliament" />
                    </v-flex>
                    <v-flex sm4>
                        <count-up :endVal="currentParties" text="Parties in current Parliament" />
                    </v-flex>
                </v-layout>
            </v-flex>
        </v-layout>
        <template>
            <v-card v-if="loading">
                <v-container fluid>
                    <v-layout row wrap>
                        <v-flex xs12>
                            <div class="loader"></div>
                        </v-flex>
                    </v-layout>
                </v-container>
            </v-card>
        </template>

        <div v-show="!loading">
            <v-layout row wrap align-center>
                <v-flex xs12>
                    <v-layout row wrap align-center>
                        <v-flex xs12 md12 xl12>
                            <v-layout row wrap align-center>
                                <v-flex xs12 sm6 md4 xl4 >
                                    <v-card-title class=" pb-xs-0 pb-4 mb-0 pl-0">
                                        <statistical-member-or-senator-selector :value="selectedMpOrSenator" :alternateText="true" 
                                        @input="selectedMpOrSenator = $event" class="mr-4" />
                                        <v-text-field :class="{mobileTextField: isMobile}" v-on:keyup="TRACK_SEARCH" v-model="search" 
                                            append-icon="search" label="Search parties" single-line hide-details>
                                        </v-text-field>
                                        <v-menu v-if="this.isMobile" d-inline offset-y :nudge-left="140" :close-on-content-click="true">
                                            <v-btn outline small slot="activator">
                                                Sort <v-icon>sort</v-icon>
                                            </v-btn>
                                            <v-list>
                                                <v-subheader>Sort by: </v-subheader>
                                                <v-list-tile v-for="(item, index) in HEADERS.filter(h => h.text != '' && h.sortable != false)" :key="item.value" @click="changeSort(item.value)">
                                                    <v-list-tile-title>
                                                        {{ item.text }}
                                                        <v-icon v-if="PAGINATION.sortBy === item.value">{{PAGINATION.descending ? 'arrow_downward':'arrow_upward'}}</v-icon>
                                                    </v-list-tile-title>
                                                </v-list-tile>
                                            </v-list>
                                        </v-menu>
                                    </v-card-title>
                                </v-flex>
                                <v-flex xs12 sm6 md4 xl4>
                                    <v-autocomplete class="pb-0 pt-4 pt-xs-0 mb-0 pl-3 pl-xs-0" label="Select a Parliament" v-model="SELECTED_PARLIAMENTS"
                                        :items="this.$store.getters.GET_PARLIAMENTS_ORDERED" item-text="Name" item-value="PID"
                                        v-on:change="FILTERBY_PARLIAMENT" :filter="FILTER_PARLIAMENT_OPTIONS" auto-select-first
                                        multiple small-chips clearable deletable-chips>
                                        <template v-slot:selection="{ item, index }">
                                            <v-chip @input="deleteParliamentSelectionItem(item.PID)" small close v-if="index == 0">{{item.Name}}</v-chip>
                                            <v-chip small v-if="index == 1">+ {{SELECTED_PARLIAMENTS.length - 1}} more</v-chip>
                                        </template>
                                        <template v-slot:prepend-item v-if="this.$store.getters.GET_PARLIAMENTS.length > 0">
                                            <v-list-tile v-on:click="CLICK_CURRENTPARLIAMENT" :value="currentParliamentValue"  ripple>
                                                <v-list-tile-action>
                                                    <v-icon>{{ currentParliamentIcon }}</v-icon>
                                                </v-list-tile-action>
                                                <v-list-tile-content>
                                                    <v-list-tile-title>Current Parliament</v-list-tile-title>
                                                </v-list-tile-content>
                                            </v-list-tile>
                                            <v-divider></v-divider>
                                        </template>
                                    </v-autocomplete>
                                </v-flex>
                                <v-flex xs12 sm6 md4 xl4>
                                    <v-autocomplete class="pl-4 pl-xs-0 pt-4 pt-xs-0" :items="this.$store.getters.GET_STATES"
                                        item-text="Name" item-value="Abbrev" :label="stateSelectLabel" v-model="SELECTED_STATES"
                                        v-on:change="PERFORM_SEARCH"
                                        :filter="FILTER_STATE_OPTIONS" :search-input.sync="stateSearchInput"
                                        multiple small-chips deletable-chips>
                                        <template v-slot:selection="{ item, index }">
                                            <v-chip @input="deleteStateSelectionItem(item.Abbrev)" small close v-if="index == 0">{{item.Name}}</v-chip>
                                            <v-chip small v-if="index == 1">+ {{SELECTED_STATES.length - 1}} more</v-chip>
                                        </template>
                                    </v-autocomplete>
                                </v-flex>
                            </v-layout>
                        </v-flex>
                    </v-layout>
                </v-flex>
            </v-layout>
        </div>

        <div>
            <chart v-show="!loading" id="partiesInParliamentTimeline" :chartData="partiesInParliamentTimeline" />
        </div>
        
        <br />

        <div v-show="!loading">
            <v-data-table :headers="headersExtra" :items="filteredParties" :rows-per-page-items="ROWS_LISTITEMS" :hide-headers="isMobile"
                :class="{ mobileDataTable: isMobile, 'elevation-1': true }"
                :pagination.sync="PAGINATION" v-on:update:pagination="UPDATE_PAGINATION" :search="search" class="elevation-1">
                <template v-slot:items="props" >
                    <router-link v-if="isMobile" class="tr" :to="{ name: $store.state.ROUTE_PARTY, params: { Party: props.item.PartyID.toString() }}">
                        <td>
                            <div class="flex-content">
                                <div class="flex-item pt-2">
                                    <h3 class="pb-xs-0">
                                        <v-icon aria-hidden="true" class="ml-2" style="margin-right: 0.5rem" :color="props.item.Colour" small>circle</v-icon> 
                                        {{ props.item.PrimaryName }}
                                    </h3>
                                </div>
                                <div class="flex-item" data-label="Abbreviation">
                                    {{ props.item.PrimaryAbbrev }}
                                </div>
                                <div class="flex-item flex-item-col" data-label="Current members">
                                    {{ props.item.CurrentMemberCount }}
                                </div>
                                <div class="flex-item flex-item-col" data-label="Total members">
                                    {{ props.item.MemberCount}}
                                </div>
                               
                                <div class="flex-item flex-item-col" data-label="Total duration in Parliament">
                                    {{ props.item.TimeInParliament }}
                                </div>
                                <div class="flex-item flex-item-col" data-label="States">
                                    <v-progress-circular v-if="detailedPartiesLoading && props.index == 0" indeterminate size="20" color="#c7c7c7"></v-progress-circular>
                                    <span v-if="!detailedPartiesLoading">{{ props.item.States != null ? props.item.States.join(', ') : '' }}</span>
                                </div>
                            </div>
                        </td>
                    </router-link>
                    <router-link v-else class="tr" :to="{ name: $store.state.ROUTE_PARTY, params: { Party: props.item.PartyID.toString() }}">
                        <td class="text-xs-left">
                            <v-icon aria-hidden="true" class="ml-2" style="margin-right: 0.5rem" :color="props.item.Colour" small>circle</v-icon> 
                            {{ props.item.PrimaryName }}
                        </td>
                        <td class="text-xs-left">{{ props.item.PrimaryAbbrev }}</td>
                        <td class="text-xs-left">{{ props.item.CurrentMemberCount == 0 ? '' : props.item.CurrentMemberCount }}</td>
                        <td class="text-xs-left">{{ props.item.MemberCount == 0 ? '' : props.item.MemberCount}}</td>
                        <td class="text-xs-left">{{ props.item.TimeInParliament }}</td>
                        <td class="text-xs-left">
                            <v-progress-circular v-if="detailedPartiesLoading && props.index == 0" indeterminate size="20" color="#c7c7c7"></v-progress-circular>
                            <span v-if="!detailedPartiesLoading">{{ props.item.States != null ? props.item.States.join(', ') : '' }}</span>
                        </td>
                        <td class="text-xs-left">
                            <v-progress-circular v-if="detailedPartiesLoading && props.index == 0" indeterminate size="20" color="#c7c7c7"></v-progress-circular>
                            <span v-if="!detailedPartiesLoading">{{ props.item.Chambers != null ? props.item.Chambers.join(', ') : '' }}</span>
                        </td>
                        <td v-if="SELECTED_PARLIAMENTS.length > 1">
                            {{ props.item.Parliaments.join(', ').toString() }}
                        </td>
                    </router-link>
                </template>

                <template v-slot:no-results>
                    <v-alert :value="true" color="error" icon="warning">
                        Your search for "{{ search }}" found no results.
                    </v-alert>
                </template>     
            </v-data-table>

            <v-layout row wrap>
                <v-flex xs12>
                    <div style="float:right">
                        <v-btn v-on:click="EXPORTTOCSV" v-on:keyup.enter="EXPORTTOCSV" color="primary" v-if="!loading && filteredParties.length > 0">
                            <v-icon aria-hidden="true" :class="csvDownloadClass">{{csvDownloadIcon}}</v-icon>
                            <span >&nbsp;Download as CSV</span>
                        </v-btn>
                    </div>
                </v-flex>
            </v-layout>
        </div>
        <br />
        <br />
    </v-container>
  
</template>

<script>
import axios from "axios";
import CountUp from './CountUp.vue'
import Chart from './Chart.vue';
import StatisticalHeader from './StatisticalHeader.vue';
import StatisticalMemberOrSenatorSelector from './StatisticalMemberOrSenatorSelector.vue';
import { throws } from "assert";
const apiUri = window.Handbook.ApiUri || "https://localhandbookapi.aph.gov.au/";
axios.defaults.baseURL = apiUri;

export default {
    data() {    
        return {
            search:   '',
            CSV_FILENAME:     "Handbook-Parties",  
            loading: true,
            detailedPartiesLoading: true,
            isMobile: false,
            initialLoad: true,
            currentParliament: 0,
            totalParties: 0,
            currentParties: 0,
            PARLIAMENTS: this.$store.getters.GET_PARLIAMENTS,
            SELECTED_PARLIAMENTS: [],
            stateSearchInput: '',
            SELECTED_STATES: [],
            csvDownloading: false,
            hoveredPoint: null,
            hoveringLabel: false,
            selectedMpOrSenator: ['senator', 'mp'],
            ROWS_LISTITEMS: [5, 10, 50, {
                "text": "$vuetify.dataIterator.rowsPerPageAll",
                "value": -1
            }],
            PARTIES: [],
            filteredParties: [],
            PAGINATION: {
                page: this.$route.query.page ? parseInt(this.$route.query.page) : 1,
                rowsPerPage: -1
            },

            HEADERS: [
                {
                    text: 'Party name',
                    value: 'PrimaryName',
                    align: 'left'
                }, 
                {
                    text: 'Abbreviation',
                    value: 'PrimaryAbbrev',
                    align: 'left'
                },  
                {
                    text: 'Current members',
                    value: 'CurrentMemberCount',
                    align: 'left'
                }, 
                {
                    text: 'Total members',
                    value: 'MemberCount',
                    align: 'left'
                },   
                    
                {
                    text: 'Total duration in Parliament',
                    value: 'DaysInParliament',
                    align: 'left'
                },   
                {
                    text: 'States represented',
                    value: 'FilteredStates',
                    align: 'left',
                    sortable: false
                },     
                {
                    text: 'Chambers',
                    value: 'FilteredChambers',
                    align: 'left',
                    sortable: false
                },                     
            ],
        }
    },
    components: {
        CountUp,
        Chart,
        StatisticalHeader,
        StatisticalMemberOrSenatorSelector,
    },
    mounted() {
        this.onResize();
        if (this.$route.query.s) {
            this.search = this.$route.query.s;
        }

        if (this.$route.query.parliaments) {
            this.SELECTED_PARLIAMENTS = this.$route.query.parliaments
                .split(",")
                .map((p) => parseInt(p));
        }

        if (this.$route.query.chambers) {
            if (this.$route.query.chambers == "mp"){
                this.selectedMpOrSenator = ["mp"];
            }
            else {
                this.selectedMpOrSenator = ["senator"];
            }
        }

        if (this.$route.query.states) {
            this.SELECTED_STATES = this.$route.query.states
                .split(",")
                .map((p) => p.replace("%20", ""));
        } else {
            this.SELECTED_STATES = [];
        }

        if (this.$route.query.page) {
            this.PAGINATION.page = parseInt(this.$route.query.page);
        }

        if (this.$route.query.pageSize) {
            this.PAGINATION.rowsPerPage = parseInt(this.$route.query.pageSize);
        }

        this.loadParties();
    },
    watch: {
        'PAGINATION.page': function (newPage, oldPage) {
            if (typeof oldPage !== 'undefined' && newPage !== oldPage && !(this.initialLoad && newPage === 1)) {
                this.PERFORM_SEARCH();
            }
        },
        selectedMpOrSenator: function () {
            this.PERFORM_SEARCH();
        }
    },
    methods: {
        onResize() {
            if (window.innerWidth < 769){
                this.isMobile = true;
            }
            else{
                this.isMobile = false;
            }
        },
        changeSort(column) {
            if (this.PAGINATION.sortBy === column) {
                this.PAGINATION.descending = !this.PAGINATION.descending
            } 
            else {
                this.PAGINATION.sortBy = column
                this.PAGINATION.descending = false
            }
        },
        loadParties() {
            this.loading = true;
            const url ="partiesdata/parties";
                axios.get(`api/${url}`).then((response) => {
                this.PARTIES = response.data;
                this.filteredParties = response.data;
                this.totalParties = this.PARTIES.length;
                this.currentParties = this.PARTIES.filter(p => p.IsCurrent).length;
                this.loading = false;
                
                if (!this.loading && !this.detailedPartiesLoading){
                    // on initial load, have to reset the page number to what it was before
                    if (this.initialLoad && this.$route.query.page) {
                        this.$nextTick().then(() => {
                            this.$set(this.PAGINATION, 'page', parseInt(this.$route.query.page));
                            this.initialLoad = false;
                        });
                    }
                    this.PERFORM_SEARCH();
                }
            });

            const detailedUrl ="partiesdata/partiesdetailed";
                axios.get(`api/${detailedUrl}`).then((response) => {
                this.PARTIES = response.data;
                this.filteredParties = response.data;
                this.detailedPartiesLoading = false;

                if (!this.loading && !this.detailedPartiesLoading){
                    // on initial load, have to reset the page number to what it was before
                    if (this.initialLoad && this.$route.query.page) {
                        this.$nextTick().then(() => {
                            this.$set(this.PAGINATION, 'page', parseInt(this.$route.query.page));
                            this.initialLoad = false;
                        });
                    }
                    this.PERFORM_SEARCH();
                }
            });
        },
        EXPORTTOCSV() {  
            this.$gtag.event('parties download csv', {
                'event_category': 'downloads',
                'event_label': 'parties search csv download',
                'value': 1
            });          

            this.csvDownloading = true;

            let OBJ_records = [];
            let headers = ['Party name', 'Abbreviation', 'Total members', 'Current members', 'Total duration in Parliament', 'Total days in Parliament', 'States', 'Chambers'];
            let filename = `Parties`
            let index = 0;

            for (index = 0; index < this.filteredParties.length; ++index) {
                if (this.SELECTED_PARLIAMENTS.length > 0){
                    OBJ_records.push({
                        'Party name': this.filteredParties[index].PrimaryName,
                        'Abbreviation': this.filteredParties[index].PrimaryAbbrev,
                        'Total members': this.filteredParties[index].MemberCount,
                        'Current members': this.filteredParties[index].CurrentMemberCount,
                        'Total duration in Parliament': this.filteredParties[index].TimeInParliament,
                        'Total days in Parliament': this.filteredParties[index].DaysInParliament,
                        'States': this.filteredParties[index].FilteredStates != null ? this.filteredParties[index].FilteredStates.join(', ') : '',
                        'Chambers': this.filteredParties[index].FilteredChambers != null ? this.filteredParties[index].FilteredChambers.join(', ') : '',
                        'Parliaments': this.filteredParties[index].Parliaments.join(', ')
                    });
                }
                else {
                    OBJ_records.push({
                        'Party name': this.filteredParties[index].PrimaryName,
                        'Abbreviation': this.filteredParties[index].PrimaryAbbrev,
                        'Total members': this.filteredParties[index].MemberCount,
                        'Current members': this.filteredParties[index].CurrentMemberCount,
                        'Total duration in Parliament': this.filteredParties[index].TimeInParliament,
                        'Total days in Parliament': this.filteredParties[index].DaysInParliament,
                        'States': this.filteredParties[index].States != null ? this.filteredParties[index].States.join(', ') : '',
                        'Chambers': this.filteredParties[index].FilteredChambers != null ? this.filteredParties[index].FilteredChambers.join(', ') : '',
                    });
                }
            }
            this.$store.dispatch('GETCSV', { DATA: OBJ_records, HEADERS: headers, FILENAME: filename })
                .catch(this.showError)
                .finally(() => this.csvDownloading = false);
            OBJ_records = null;
            index = null;
        },
        UPDATE_PAGINATION: function (options) {
            this.$gtag.event('parties pagination items per page', {
                'event_category': 'filters',
                'event_label': `items per page: ${options.rowsPerPage}`,
                'value': 1
            });
            this.$gtag.event('parties pagination page', {
                'event_category': 'filters',
                'event_label': `page: ${options.page}`,
                'value': 1
            });
        },
        TRACK_SEARCH: function (search) {
            this.$gtag.event("filter parties by name - search", {
                event_category: "filters",
                event_label: search,
                value: 1,
            });
            return this.PERFORM_SEARCH();
        },
        FILTER_STATE_OPTIONS: function (item, queryText) {
            const abbrev = item.Abbrev.toLowerCase();
            const name = item.Name.toLowerCase();
            const searchText = queryText.toLowerCase()
            return name.indexOf(searchText) > -1 || abbrev.indexOf(searchText) > -1;
        },
        deleteStateSelectionItem(item) {
            this.SELECTED_STATES = this.SELECTED_STATES.filter(find => find !== item);
            this.PERFORM_SEARCH();
        },
        deleteParliamentSelectionItem(item) {
            this.SELECTED_PARLIAMENTS = this.SELECTED_PARLIAMENTS.filter(find => find !== item);
            this.PERFORM_SEARCH();
        },
        FILTERBY_PARLIAMENT: function (parliaments) {
            this.$gtag.event("parties parliament filter", {
                event_category: "filters",
                event_label: `parliaments selected: ${
                parliaments.length > 0 ? parliaments.join(",") : "none"
                }`,
                value: 1,
            });
            return this.PERFORM_SEARCH();
        },
        FILTER_PARLIAMENT_OPTIONS: function (item, queryText) {
            const pId = item.PID;
            const name = item.Name.toLowerCase();
            const searchText = queryText.toLowerCase();
            return (
                name.indexOf(searchText) > -1 || pId.toString().indexOf(searchText) > -1
            );
        },
        CLICK_CURRENTPARLIAMENT: function () {
            this.$nextTick(() => {
                let parliaments = this.$store.getters.GET_PARLIAMENTS_ORDERED;
                            let currentParliament = parliaments[0].PID;
                            if (this.SELECTED_PARLIAMENTS.includes(currentParliament)) {
                                let index = this.SELECTED_PARLIAMENTS.indexOf(currentParliament);
                                if (index > -1) {
                                    this.SELECTED_PARLIAMENTS.splice(index, 1);
                                }
                            } else {
                                this.SELECTED_PARLIAMENTS.push(currentParliament);
                            }
                this.FILTERBY_PARLIAMENT(this.SELECTED_PARLIAMENTS);
            });
        },
        PERFORM_SEARCH: function () {
            let query = this.$router.query || {};

            if (this.search) {
                query.s = this.search;
            }
            
            this.filteredParties = this.PARTIES.slice()
                .filter(i => (i.PrimaryName.toLowerCase().indexOf(this.search.toLowerCase()) > -1)
                    || (i.PrimaryAbbrev.toLowerCase().indexOf(this.search.toLowerCase()) > -1));

            
            this.filteredParties.forEach(p => {
                p.Chambers = [];
                p.PartyDemographics.forEach(d => {
                    d.States.forEach(state => {
                        if (state.MemberCount != 0 && p.Chambers.indexOf('House') === -1)
                        {
                            p.Chambers.push('House');
                        }
                        if (state.SenatorCount != 0 && p.Chambers.indexOf('Senate') === -1)
                        {
                            p.Chambers.push('Senate');
                        }
                    });
                });
            });

            if (this.selectedMpOrSenator.length == 1) {
                this.filteredParties.forEach(p => {
                    p.FilteredChambers = [];
                    p.PartyDemographics.forEach(d => {
                        if (this.SELECTED_PARLIAMENTS.find(sp => sp == d.Parliament) !== undefined || this.SELECTED_PARLIAMENTS.length == 0) {
                            d.States.forEach(state => {
                                if (this.SELECTED_STATES.length == 0 || this.SELECTED_STATES.find(s => s.toLowerCase() == state.State.toLowerCase()) !== undefined){
                                    if (this.selectedMpOrSenator[0] == 'mp' && state.MemberCount != 0 && p.FilteredChambers.indexOf('House') === -1)
                                    {
                                        p.FilteredChambers.push('House');
                                    }
                                    if (this.selectedMpOrSenator[0] == 'senator' && state.SenatorCount != 0 && p.FilteredChambers.indexOf('Senate') === -1)
                                    {
                                        p.FilteredChambers.push('Senate');
                                    }
                                }
                            });
                        }
                    });
                });

                var filterOnChamber = this.selectedMpOrSenator[0] == 'mp' ? 'House' : 'Senate';

                this.filteredParties = this.filteredParties.filter(i => i.FilteredChambers != null && i.FilteredChambers.filter(e => 
                    e == filterOnChamber).length > 0);
            }
            else {
                this.filteredParties.forEach(p => {
                    p.FilteredChambers = [];
                    p.PartyDemographics.forEach(d => {
                        d.States.forEach(state => {
                            if (this.SELECTED_STATES.length == 0 || this.SELECTED_STATES.find(s => s.toLowerCase() == state.State.toLowerCase()) !== undefined){
                                if (state.MemberCount != 0 && p.FilteredChambers.indexOf('House') === -1)
                                {
                                    p.FilteredChambers.push('House');
                                }
                                if (state.SenatorCount != 0 && p.FilteredChambers.indexOf('Senate') === -1)
                                {
                                    p.FilteredChambers.push('Senate');
                                }
                        }
                        });
                    });
                });
            }

            if (this.SELECTED_STATES.length > 0) {
                if (this.filteredParties.length === 0) {
                    this.filteredParties = this.PARTIES.slice();
                }

                this.filteredParties = this.filteredParties.filter(i => i.States != null && i.States.filter(e => 
                    this.SELECTED_STATES.find(s => s.toLowerCase() == e.toLowerCase()) !== undefined).length > 0);

                this.filteredParties.forEach(p => {
                    p.FilteredStates = [];
                    p.PartyDemographics.forEach(d => {
                        if ((this.SELECTED_PARLIAMENTS.find(sp => sp == d.Parliament) !== undefined) || this.SELECTED_PARLIAMENTS.length == 0) {
                            d.States.forEach(state => {
                                if (this.SELECTED_STATES.find(s => s.toLowerCase() == state.State.toLowerCase()) !== undefined){
                                    if (p.FilteredStates.indexOf(state.State) === -1)
                                    {
                                        p.FilteredStates.push(state.State);
                                    }
                                }
                                
                            });
                        }
                    });
                });

                this.filteredParties = this.filteredParties.filter(i => i.FilteredStates != null && i.FilteredStates.length > 0);
            }
            else {
                this.filteredParties.forEach(p => {
                    p.FilteredStates = [];
                    p.PartyDemographics.forEach(d => {
                        if (this.SELECTED_PARLIAMENTS.find(sp => sp == d.Parliament) !== undefined || this.SELECTED_PARLIAMENTS.length == 0) {
                            d.States.forEach(state => {
                                if (p.FilteredStates.indexOf(state.State) === -1)
                                {
                                    p.FilteredStates.push(state.State);
                                }
                            });
                        }
                    });
                });
            }


            if (this.SELECTED_PARLIAMENTS.length > 0) {
                
                this.filteredParties = this.filteredParties.filter(i => i.PartyDateRecords != null && 
                    i.PartyDateRecords.filter(e => e.Parliaments.filter(p => this.SELECTED_PARLIAMENTS.find(sp => sp == p) !== undefined).length > 0).length > 0
                );

                this.filteredParties.forEach(p => {
                    p.Parliaments = [];
                    p.PartyDateRecords.forEach(d => {
                        d.Parliaments.forEach(parl => {
                            if (this.SELECTED_PARLIAMENTS.find(sp => sp == parl) !== undefined && !p.Parliaments.includes(parl)) {
                                p.Parliaments.push(parl);
                            }
                        });
                    });
                });
            }

            if (!this.search  && this.SELECTED_STATES.length == 0 && this.SELECTED_PARLIAMENTS.length == 0 && this.selectedMpOrSenator.length != 1) {
                this.filteredParties = this.PARTIES.slice();
            }

            if (this.SELECTED_PARLIAMENTS.length > 0) {
                query.parliaments = this.SELECTED_PARLIAMENTS.join(",");
            }

            if (this.selectedMpOrSenator.length == 1) {
                query.chambers = this.selectedMpOrSenator[0];
            }

            if (this.SELECTED_STATES.length > 0) {
                query.states = this.SELECTED_STATES.join(",");
            }

            if (this.PAGINATION.page && !(this.initialLoad && this.PAGINATION.page === 1)) {
                query.page = this.PAGINATION.page;
            }

            if (this.PAGINATION.rowsPerPage != 50 && this.PAGINATION.rowsPerPage != -1) {
                query.pageSize = this.PAGINATION.rowsPerPage;
            }

            if (Object.keys(query).length > 0) {
                history.replaceState(
                {},
                null,
                this.$route.path +
                    "?" +
                    Object.keys(query)
                    .map((key) => {
                        return key + "=" + query[key];
                    })
                    .join("&")
                );
            } else {
                history.replaceState({}, null, this.$route.path);
            }
        },
    },

    computed: {
        headersExtra: function() {
            var headers = [...this.HEADERS];

            if (this.SELECTED_PARLIAMENTS.length > 1) {
                headers.push(
                {
                    text: 'Parliaments',
                    align: 'left',
                    value: 'Parliaments'
                });
            } 
            return headers;
        },
        currentParliamentIcon: function () {
            let parlArray = this.$store.getters.GET_PARLIAMENTS_ORDERED;
            let currentParliament = parlArray[0].PID;
            if (this.SELECTED_PARLIAMENTS.indexOf(currentParliament) > -1) {
                return '$vuetify.icons.checkboxOn';
            } else {
                return '$vuetify.icons.checkboxOff';
            }
        },
        currentParliamentValue: function () {
            let parlArray = this.$store.getters.GET_PARLIAMENTS;
            if (
                this.SELECTED_PARLIAMENTS.includes(parlArray[parlArray.length - 1].PID)
            ) {
                return parlArray[parlArray.length - 1].PID;
            } else {
                return false;
            }
        },
        stateSelectLabel: function () {
            var label = 'Select a State';
            if (this.$vuetify.breakpoint.name === 'xs' || this.$vuetify.breakpoint.name === 'sm') {
                label = 'State';
            }
            return label;
        },
        csvDownloadIcon(){
            return this.csvDownloading ? 'cached' : 'text_snippet';
        },
        csvDownloadClass(){
            let csvClass = 'mr-1';
            if (this.csvDownloading){
                csvClass = csvClass + ' loading'
            }
            return csvClass;
        },
        partiesInParliamentTimeline() {
                var that = this;
                let data = [];
                let categories = [];

                var min = new Date(1901,1,1).valueOf()
                var max = new Date().valueOf();

                this.filteredParties.filter(p => p.PartyDateRecords.length > 0).sort(function(a,b){
                    // Turn your strings into dates, and then subtract them
                    // to get a value that is either negative, positive, or zero.
                    return new Date(a.PartyDateRecords[0].StartDate) - new Date(b.PartyDateRecords[0].StartDate);
                    }).forEach((p, pi) => {
                    p.PartyDateRecords.forEach((d, i) => {
                        // add in item. if previous item is connected, just edit latest item
                        if (i === 0) {
                            categories.push(p.PrimaryName + (p.IsCurrent ? '*' : ''));
                            data.push({
                                Party: p.PrimaryName + (p.IsCurrent ? '*' : ''),
                                PartyID: p.PartyID,
                                TotalMembers: p.MemberCount,
                                CurrentMembers: p.CurrentMemberCount,
                                TimeInParliament: p.TimeInParliament,
                                StatesRepresented: !this.detailedPartiesLoading && p.States != null ? p.States.join(", "): '',
                                x: new Date(d.StartDate).valueOf(),
                                x2: d.EndDate == null ? new Date().valueOf():  new Date(d.EndDate).valueOf(),
                                y: pi,
                                color: p.Colour
                            });
                        }
                        else {
                            const previous = p.PartyDateRecords[i - 1];
                            // if joined
                            if (new Date(previous.EndDate).addDays(1) >= new Date(d.StartDate)
                            && previous.Party == d.Party) {
                                // join
                                data[data.length - 1].x2 = d.EndDate == null ?  new Date().valueOf(): new Date(d.EndDate).valueOf();
                            } else {
                                data.push({
                                    Party: p.PrimaryName + (p.IsCurrent ? '*' : ''),
                                    PartyID: p.PartyID,
                                    TotalMembers: p.MemberCount,
                                    CurrentMembers: p.CurrentMemberCount,
                                    TimeInParliament: p.TimeInParliament,
                                    StatesRepresented: !this.detailedPartiesLoading && p.States != null ? p.States.join(", "): '',
                                    x: new Date(d.StartDate).valueOf(),
                                    x2: d.EndDate == null ?  new Date().valueOf():  new Date(d.EndDate).valueOf(),
                                    y: pi,
                                    color: p.Colour
                                });
                            }
                        }
                    });
                });

                return {
                    chart: {
                        marginLeft: this.isMobile ? 0 : 400,
                        type: 'xrange',
                        height: this.filteredParties.length < 20 ? (this.isMobile ? 300 : 500) : (this.isMobile ?  this.filteredParties.length * 6 : this.filteredParties.length * 15),
                        events: {
                            render: function() {
                                var axis = this.yAxis[0];
                                var ticks = axis.ticks;
                                var points = this.series[0].points;
                                var chart = this;
                                if (!that.isMobile){
                                    Object.keys(ticks).forEach(function(t,index) {
                                        var tick = ticks[index];
                                        if (tick){
                                            var label = tick.label.element;
                                            var point = points.find(p => p.Party == tick.label.textStr);

                                            if (point ){
                                                label.onclick = function() {
                                                    that.hoveredPoint = point;
                                                    that.$router.push({ name: that.$store.state.ROUTE_PARTY, params: { Party: point.PartyID.toString() }});
                                                }

                                                label.onmouseover = function() {
                                                    that.hoveredPoint = point;
                                                    that.hoveringLabel = true;
                                                    chart.tooltip.refresh(point)
                                                } 
                                                
                                                label.onmouseout = function() {
                                                    chart.tooltip.hide();
                                                    that.hoveringLabel = false;
                                                }
                                            }
                                        }
                                    });
                                }
                            }
                        }
                    },
                    plotOptions: {
                        series: {
                            minPointLength: 10,
                            cursor: 'pointer',
                            point: {
                                events: {
                                    click: function () {
                                        that.hoveredPoint = this;
                                        that.$router.push({ name: that.$store.state.ROUTE_PARTY, params: {  Party: this.PartyID.toString() }});
                                    },
                                    mouseOver: function() {
                                        that.hoveredPoint = this;
                                        that.hoveringLabel = false;
                                    },
                                    mouseOut: function() {
                                        that.hoveredPoint = null;
                                        that.hoveringLabel = false;
                                    }
                                }
                            }
                        }
                    },
                    tooltip: {
                        borderWidth: 0,
                        backgroundColor: 'transparent',
                        shadow: false,
                        enabled: this.isMobile ? false : true,
                        useHTML: true,
                        formatter: function () {
                            var todaysDate = new Date();
                            var dateIsToday = new Date(this.x2).setHours(0,0,0,0) == todaysDate.setHours(0,0,0,0);
                            var showEndDate = dateIsToday ? 'present' : new Date(this.x2).toLocaleDateString('en-AU');

                            var tooltipMarkup = '<div class="tooltip" style="width:400px;min-height: 100px;">'
                            + '<div style="vertical-align: top;display:inline-block; width:350px; padding-left:10px;">' 
                     
                            + (!that.hoveringLabel ? 
                                ('<p style="font-size:1.1em;font-weight:bold;white-space: normal;">' + this.point.Party + '</p>' 
                                + '<p style="white-space: normal; margin-bottom:0.5rem;">' + new Date(this.x).toLocaleDateString('en-AU') + ' - ' + showEndDate + '</p>')
                                : '<p style="font-size:1.1em;font-weight:bold;white-space: normal;">' + this.point.Party + '</p>' 

                                + (this.point.Party.indexOf('*') > -1 ? '<p style="white-space: normal; margin-bottom:0.5rem;">* In current Parliament</p>': '')
                                +'<p style="white-space: normal; margin-bottom:0.5rem;">Total duration in Parliament: ' + this.point.TimeInParliament + '</p>'
                                +'<p style="white-space: normal; margin-bottom:0.5rem;">Total members: ' + this.point.TotalMembers + '</p>'
                                +'<p style="white-space: normal; margin-bottom:0.5rem;">Current members: ' + this.point.CurrentMembers + '</p>'
                                +'<p style="white-space: normal; margin-bottom:0.5rem;">States represented: ' + this.point.StatesRepresented + '</p>')
                            + '</div></div>';
                       
                            return tooltipMarkup ;
                        },    
                        positioner: function() {
                            var x = that.hoveredPoint.shapeArgs.x;
                            var y = that.hoveredPoint.shapeArgs.y;
                         
                            return {
                                x: that.hoveringLabel ? 380 : x + 80,
                                y: y + 40
                            }
                        },
                    },

                    legend: {
                        enabled: false
                    },

                    title: {
                        text: 'Parties in Parliament over time'
                    },
                    exporting: {
                        filename: 'Parties in Parliament over time',
                        sourceWidth: 2000
                    },
                    xAxis: {
                        type: 'datetime',
                        min: min,
                        max: max
                    },
                    yAxis: {
                        title: {
                            text: ''
                        },
                        type: 'category',
                        labels: {
                            enabled: this.isMobile ? false : true,
                            step: 1,
                            style: {
                                cursor: 'pointer'
                            },
                        },
                        categories,
                        reversed: true
                    },
                    series: [{
                        name: 'Parties',
                        pointWidth: this.isMobile ? 3 : 10,
                        data,
                    }]                    
                }
            },
    }
}
</script>

<style lang="stylus" scoped>
  .v-progress-circular {
    margin: 1rem
  };

a {
    color: #fff;
    text-decoration: underline;
}
</style>

<style lang="stylus" scoped>

#partiesInParliamentTimeline >>> div {
    overflow: visible !important;
  }


#partiesInParliamentTimeline >>> .highcharts-container {
    overflow: visible !important;
  }

  #partiesInParliamentTimeline >>> .highcharts-container svg {
    overflow: visible !important;
  }

  #partiesInParliamentTimeline >>> .highcharts-tooltip span {
    background-color: transparent;
}   
  #partiesInParliamentTimeline >>> .highcharts-yaxis-labels text {
        cursor: pointer !important;
    }


</style>
